import ReactTooltip, { TooltipProps } from 'react-tooltip';

export const Tooltip = ({
  effect = 'solid',
  place = 'top',
  ...props
}: TooltipProps) => <ReactTooltip {...props} effect={effect} place={place} />;
